import React from 'react';
import PropTypes from 'prop-types';
import { formMessageConstants } from '../../../utils/constants/form-message-constants';
import { isEmpty } from '../../../utils/obj-utils';

function FileContentSummary({ fileContents, noProductsFoundText }) {
    function displayProducts() {
        if (isEmpty(fileContents)) {
            return (<div className='no-files'>
                <p className='info'>{noProductsFoundText}</p>
            </div>);
        }

        return fileContents.map((fileContent, index) => {
            const isLast = index + 1 === fileContents.length;
            return (
                <div key={index} className={`product ${isLast ? 'last' : ''}`}>
                    <div className='product-description'>
                        <svg aria-hidden='true'
                            focusable='false'
                            data-prefix='far'
                            data-icon='calendar-alt'
                            role='img'
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 448 512'
                            className='icon-calendar'>
                            <path fill='#2269AB'
                                d='M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z'
                                className=''>
                            </path>
                        </svg>
                        {displayInfoText(fileContent)}
                    </div>
                    {displayFunctionContentTable(fileContent)}
                </div >);
        });
    }

    function displayInfoText({ name, details }) {
        return (<div className='info'>
            <p className='sub-title'>{`${name || formMessageConstants.emptyString}`}</p>
            <p className='description'>{`${details || formMessageConstants.emptyString}`}</p>
        </div>);
    }

    function displayFunctionContentTable({ fileContentItems, formattedTotalAmount }) {
        return fileContentItems.map((fileContentItem, index) => {
            const isLast = index + 1 === fileContentItems.length;
            return (
                <div className='table' key={index}>
                    <div className='flex-grid table-header'>
                        <div className='col'>{formMessageConstants.Type}</div>
                        <div className='col text-center'>{formMessageConstants.qty}</div>
                        <div className='col'>{formMessageConstants.unitPrice}</div>
                        <div className='col text-right'>{formMessageConstants.subTotal}</div>
                    </div>

                    <div className='flex-grid'>
                        <div className='col'>{`${fileContentItem.type}`}</div>
                        <div className='col text-center'>{`${fileContentItem.quantity}`}</div>
                        <div className='col'> {`${fileContentItem.formattedUnitPrice}`}</div>
                        <div className='col text-right'>{`${fileContentItem.formattedSubTotal}`}</div>
                    </div>

                    {isLast && (<div className='flex-grid table-footer'>
                        <div className='col text-right'>{`Sub-total = ${formattedTotalAmount}`}</div>
                    </div>)}
                </div >);
        });
    }

    return (
        <div className='file-content'>
            <h2>{formMessageConstants.fileContent}</h2>
            {displayProducts()}
        </div>
    );
}

FileContentSummary.propTypes = {
    fileContents: PropTypes.array.isRequired,
    noProductsFoundText: PropTypes.string
};

export default FileContentSummary;
